import React from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./congratsPop.module.scss";
import congratsImg from "../../../assets/images/congratsPopBg.png";
import jackpotD1 from "../../../assets/images/usdt.png";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

const CongratulationPop2 = ({ winningData, congrats2, setCongrats2 }) => {
  // const { t } = useTranslation();
  const t = useLanguage();

  const handledHide = () => {
    setCongrats2(!congrats2);
  };
  return (
    <>
      <Modal
        show={congrats2}
        // onHide={handledHide}
        backdrop="true"
        centered
        className={`${styles.congratsPop}`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body>
            <Button
              onClick={handledHide}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: "33%", right: "14%", zIndex: 99 }}
            >
              {closeIcn}
            </Button>
            <div className="text-center">
              <div className="position-relative">
                <img src={congratsImg} alt="" className="img-fluid w-100" />
              </div>
              <div className={`${styles.contentWrpper} position-absolute`}>
                <div className="d-flex justify-content-center align-items-center">
                  <h3 className="fw-bold text-white m-0">
                    {/* {winningData?.name} */}
                    {t("congratulation_pop.congrats")} <br />
                    {t("congratulation_pop.you_won")}
                  </h3>
                </div>
                <div className="d-flex align-items-center justify-content-center mt-3 gap-10">
                  <h2
                    className={`${styles.price} m-0 fw-bold d-flex gap-10 items-center`}
                  >
                    {winningData?.amount}
                    <span className="icn">
                      <img
                        style={{ height: 60 }}
                        src={jackpotD1}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </span>
                  </h2>
                </div>
                <div className="my-4 text-center">
                  <Button
                    onClick={() => handledHide()}
                    style={{ maxWidth: 167 }}
                    className="d-inline-flex text-uppercase align-items-center justify-content-center border-0"
                  >
                    {t("congratulation_pop.claim")}
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default CongratulationPop2;

const closeIcn = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.002 0C20.1828 0 26.0046 5.82113 26.0049 13.002C26.0049 20.183 20.183 26.0049 13.002 26.0049C5.82113 26.0046 0 20.1828 0 13.002C0.000241198 5.82128 5.82128 0.000241204 13.002 0ZM6.68359 7.83398L11.8604 13.0029L6.68359 18.1709L7.83789 19.3252L13.0059 14.1484L18.1748 19.3252L19.3203 18.1709L14.1523 13.0029L19.3203 7.83398L18.1748 6.68848L13.0059 11.8564L7.83789 6.67969L6.68359 7.83398Z"
      fill="white"
      fillOpacity="0.7"
    />
  </svg>
);
